<template>
  <div
    ref="scrollDivRef"
    class="flex items-center text-primary-100 overflow-auto sm:overflow-visible whitespace-nowrap sm:whitespace-normal py-2 pr-4 sm:p-0"
  >
    <span class="u-center">
      <OLink href="/" class="text-md">{{ showHomePageTitle ? $t('main.homepage') : $t('main.breadcrumbRoot') }}</OLink>
      <OIcon v-if="items.length" icon="chevron-right-grey" class="mr-4 ml-4 w-[7px] h-3" />
    </span>
    <OBreadcrumbItem v-for="(item, index) in items" :key="item.name" :item="item" :last-item="index === items.length - 1" />
  </div>
</template>
<script>
import { defineComponent, onMounted, ref } from '@nuxtjs/composition-api';
import OBreadcrumbItem from './OBreadcrumbItem';
import { OIcon, OLink } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OBreadcrumbItem, OLink, OIcon },
  props: {
    items: {
      type: Array,
      default: [],
    },
    showHomePageTitle: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const scrollDivRef = ref();
    onMounted(() => {
      scrollDivRef.value.scrollLeft = scrollDivRef.value.scrollWidth;
    });
    return { scrollDivRef };
  },
});
</script>
